export const shouldShowActionButton = (item, conferenceYear, getNow) => {
  const sessionDate = item?.date

  if (!sessionDate) {
    return item?.conferenceYear < conferenceYear
  }
  return sessionDate <= getNow()
}
